export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f84b78f613d6913d40451321a5f230843473f8317&name=fetchTypeahead!'